import { render, staticRenderFns } from "./promotions-product-ad-detail.vue?vue&type=template&id=4845b703&scoped=true&"
import script from "./promotions-product-ad-detail.vue?vue&type=script&lang=js&"
export * from "./promotions-product-ad-detail.vue?vue&type=script&lang=js&"
import style0 from "./promotions-product-ad-detail.vue?vue&type=style&index=0&id=4845b703&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845b703",
  null
  
)

export default component.exports